import React, { useContext } from "react";
import { AlertBox } from "../../../AlertBox";
import { Flex } from "../../../Flex";
import { ModalBody } from "../../../Modal";
import { GenericFormContext } from "../../GenericFormContext";
/**
 * FormModalBody provides the main "body" wrapper for a form that is within
 * a Modal. The children would usually be form inputs, wrapped in a
 * FormFieldGroup.
 */
export const FormModalBody = ({ children }) => {
    const { submissionError } = useContext(GenericFormContext);
    return (React.createElement(ModalBody, null,
        React.createElement(Flex, { mx: 24, mt: 32, mb: 16, flexDirection: "column" },
            submissionError && (React.createElement(AlertBox, { mb: 16, variant: "error" }, submissionError)),
            children)));
};
